'use strict';

var immer = require('immer');
var utils_appRegion = require('../utils/appRegion.js');
var jsonSchema_fakerUpgrade = require('./fakerUpgrade.js');
var jsonSchema_mockUpgrade = require('./mockUpgrade.js');
var jsonSchema_traverse = require('./traverse.js');
var jsonSchema_utils = require('./utils.js');
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var _Immer = new immer.Immer({
    autoFreeze: false
  }),
  produce = _Immer.produce;
var defaultOneOfSchema = function defaultOneOfSchema() {
  return _defineProperty({
    type: 'object',
    properties: {}
  }, "x-".concat(utils_appRegion.getAppNameLower(), "-orders"), []);
};

/**
 * 将 JsonSchema4 -> JsonSchema 扩展
 *
 * @param schema
 * @returns
 */
function JsonSchemaStandard2AppJsonSchema(schema, options) {
  var transformOptions = _objectSpread({
    enableXAppMock: false,
    enableXAppEnum: false,
    enableMockjsAutoTransformFakerjs: false
  }, options);
  var _getAllExpendKeys = jsonSchema_utils.getAllExpendKeys(),
    expend$RefsKey = _getAllExpendKeys.expend$RefsKey,
    expendOrdersKey = _getAllExpendKeys.expendOrdersKey,
    expendIgnorePropertiesKey = _getAllExpendKeys.expendIgnorePropertiesKey,
    expendMockKey = _getAllExpendKeys.expendMockKey,
    expendKey = _getAllExpendKeys.expendKey,
    expendEnumDescriptionKey = _getAllExpendKeys.expendEnumDescriptionKey;
  return produce(schema, function (draft) {
    jsonSchema_traverse.default(draft, function (draftSchema) {
      if (_typeof(draftSchema) !== 'object') return;
      // required 属性按照规范进行调整，typescript 定义中，多了一个 false 的情况
      if (Array.isArray(draftSchema.required)) {
        if (draftSchema.required.length === 0) {
          delete draftSchema.required;
        }
      } else if (draftSchema.required !== undefined) {
        delete draftSchema.required;
      }
      var mainType = jsonSchema_utils.getMainType(draftSchema);
      if (draftSchema[expend$RefsKey]) {
        draftSchema.$ref = draftSchema[expend$RefsKey];
        delete draftSchema.type;
        delete draftSchema.properties;
        mainType = 'ref';
        delete draftSchema.required;
        delete draftSchema[expend$RefsKey];
        delete draftSchema[expendIgnorePropertiesKey];
      }
      ['oneOf', 'anyOf', 'allOf'].forEach(function (key) {
        if (Array.isArray(draftSchema[key])) {
          var filterArray = draftSchema[key].filter(Boolean);
          if (filterArray.length === 0) {
            draftSchema[key] = [defaultOneOfSchema(), defaultOneOfSchema()];
          } else {
            draftSchema[key] = filterArray;
          }
        }
      });

      // fix openapi 3.0 nullable spec 2 json schema 7
      if (draftSchema.nullable === true) {
        if (draftSchema.type) {
          var type = (Array.isArray(draftSchema.type) ? draftSchema.type : [draftSchema.type]).filter(function (v) {
            return v !== 'null';
          });
          draftSchema.type = [].concat(_toConsumableArray(Array.from(new Set(type))), ['null']);
        } else if (draftSchema.$ref) {
          delete draftSchema.nullable;
          var collectSubSchema = _objectSpread({}, draftSchema);
          // emptyAll
          Object.keys(draftSchema).forEach(function (k) {
            delete draftSchema[k];
          });
          draftSchema.oneOf = [collectSubSchema, {
            type: 'null'
          }];
        } else {
          draftSchema.type = 'null';
        }
      }
      if (draftSchema.nullable !== undefined) {
        delete draftSchema.nullable;
      }
      if (mainType === 'object') {
        if (draftSchema.properties) {
          var _draftSchema$expendIg;
          (_draftSchema$expendIg = draftSchema[expendIgnorePropertiesKey]) === null || _draftSchema$expendIg === void 0 || _draftSchema$expendIg.forEach(function (v) {
            var _draftSchema$properti;
            (_draftSchema$properti = draftSchema.properties) === null || _draftSchema$properti === void 0 || delete _draftSchema$properti[v];
          });
        }
        if (draftSchema.required && Array.isArray(draftSchema.required)) {
          draftSchema.required = draftSchema.required.filter(function (v) {
            return draftSchema.properties && v in draftSchema.properties;
          });
          if (draftSchema.required.length === 0) delete draftSchema.required;
        }
        delete draftSchema[expendIgnorePropertiesKey];
        draftSchema[expendOrdersKey] = getActiveXAppOrder(draftSchema);
        // draftSchema.properties = reOrderProps(draftSchema);
      }
      if (mainType === 'ref') {
        delete draftSchema.type;
      }
      if (mainType === 'number') {
        jsonSchema_utils.schemaToBigintString(draftSchema);
      }
      // TODO 补充 json4 -> json7 的升级代码

      if (draftSchema.exclusiveMaximum === true) {
        if (draftSchema.maximum !== undefined) {
          draftSchema.exclusiveMaximum = draftSchema.maximum;
        } else {
          delete draftSchema.exclusiveMaximum;
        }
      } else if (draftSchema.exclusiveMaximum === false) {
        delete draftSchema.exclusiveMaximum;
      } else if (typeof draftSchema.exclusiveMaximum === 'number') {
        draftSchema.maximum = draftSchema.exclusiveMaximum;
      }
      if (draftSchema.exclusiveMinimum === true) {
        if (draftSchema.minimum !== undefined) {
          draftSchema.exclusiveMinimum = draftSchema.minimum;
        } else {
          delete draftSchema.exclusiveMinimum;
        }
      } else if (draftSchema.exclusiveMinimum === false) {
        delete draftSchema.exclusiveMinimum;
      } else if (typeof draftSchema.exclusiveMinimum === 'number') {
        draftSchema.minimum = draftSchema.exclusiveMinimum;
      }

      // 将example塞到examples中
      var example = draftSchema.example;
      if (example !== undefined) {
        if (Array.isArray(draftSchema.examples)) {
          if (!draftSchema.examples.includes(example)) {
            draftSchema.examples.push(example);
          }
        } else {
          draftSchema.examples = [example];
        }
      }
      delete draftSchema.example;

      // enum和const互斥，enum优先
      if (Array.isArray(draftSchema["enum"])) {
        delete draftSchema["const"];
      }

      // !! 这两个值是可以同时出现在数据结构的。但是只是在 新版改完，然后旧版本再修改，然后再也没有使用新版本客户端修改的情况下，这些兼容字段会出现并存的情况。但是新的字段总是有的，旧的字段在新版本打开或者编辑就没有了
      // @depreacted 废弃 {mock: {mock: string}} / {faker: {faker: string}}
      if (transformOptions.enableXAppMock) {
        if ('mock' in draftSchema) {
          var _draftSchema$mock, _draftSchema$mock2, _draftSchema$mock3;
          if (_typeof(draftSchema.mock) === 'object' && (typeof ((_draftSchema$mock = draftSchema.mock) === null || _draftSchema$mock === void 0 ? void 0 : _draftSchema$mock.mock) === 'number' || typeof ((_draftSchema$mock2 = draftSchema.mock) === null || _draftSchema$mock2 === void 0 ? void 0 : _draftSchema$mock2.mock) === 'string' && (_draftSchema$mock3 = draftSchema.mock) !== null && _draftSchema$mock3 !== void 0 && _draftSchema$mock3.mock)) {
            var _draftSchema$expendMo;
            (_draftSchema$expendMo = draftSchema[expendMockKey]) !== null && _draftSchema$expendMo !== void 0 ? _draftSchema$expendMo : draftSchema[expendMockKey] = draftSchema.mock.mock;
          }
          delete draftSchema.mock;
        }
        if ('faker' in draftSchema) {
          if (typeof draftSchema.faker === 'string' && draftSchema.faker) {
            var _draftSchema$expendMo2;
            (_draftSchema$expendMo2 = draftSchema[expendMockKey]) !== null && _draftSchema$expendMo2 !== void 0 ? _draftSchema$expendMo2 : draftSchema[expendMockKey] = jsonSchema_fakerUpgrade.fakerUpgrade(draftSchema.faker);
          }
          delete draftSchema.faker;
        }
      }
      if (transformOptions.enableMockjsAutoTransformFakerjs) {
        if (typeof draftSchema[expendMockKey] === 'string') {
          draftSchema[expendMockKey] = jsonSchema_mockUpgrade.mockUpgrade(draftSchema[expendMockKey]);
        }
      }
      if (transformOptions.enableXAppEnum) {
        // @depreacted 废弃 {x-apidog: {enumDescriptions: {"1": 1}}}
        // @depreacted 废弃 {x-apidog: {enumDescriptions: {"1": 1}}}
        if (Array.isArray(draftSchema["enum"]) && expendKey in draftSchema) {
          var _draftSchema$expendKe;
          if (_typeof(draftSchema[expendKey]) === 'object' && _typeof((_draftSchema$expendKe = draftSchema[expendKey]) === null || _draftSchema$expendKe === void 0 ? void 0 : _draftSchema$expendKe.enumDescriptions) === 'object') {
            var _draftSchema$expendEn;
            (_draftSchema$expendEn = draftSchema[expendEnumDescriptionKey]) !== null && _draftSchema$expendEn !== void 0 ? _draftSchema$expendEn : draftSchema[expendEnumDescriptionKey] = draftSchema["enum"].map(function (v) {
              var _draftSchema$expendKe2, _draftSchema$expendKe3;
              return {
                name: '',
                value: v,
                description: (_draftSchema$expendKe2 = (_draftSchema$expendKe3 = draftSchema[expendKey]) === null || _draftSchema$expendKe3 === void 0 || (_draftSchema$expendKe3 = _draftSchema$expendKe3.enumDescriptions) === null || _draftSchema$expendKe3 === void 0 ? void 0 : _draftSchema$expendKe3[String(v)]) !== null && _draftSchema$expendKe2 !== void 0 ? _draftSchema$expendKe2 : ''
              };
            });
          }
          delete draftSchema[expendKey];
        }
      }
    });
  });
}
function getActiveXAppOrder(schema) {
  var _getAllExpendKeys2 = jsonSchema_utils.getAllExpendKeys(),
    expendRefsKey = _getAllExpendKeys2.expendRefsKey,
    expendOrdersKey = _getAllExpendKeys2.expendOrdersKey;
  var allPropertiesDefaultOrder = Object.keys(schema.properties || {}).concat(Object.keys(schema[expendRefsKey] || {}));
  var xAppOrders = schema[expendOrdersKey];
  if (!Array.isArray(xAppOrders)) {
    return allPropertiesDefaultOrder;
  }
  // 排除已删除节点
  var pickExistFieldOrder = Array.from(new Set(xAppOrders.filter(function (v) {
    return allPropertiesDefaultOrder.includes(v);
  })));
  // 未包含在 order 的节点
  var restOrder = Array.from(new Set(allPropertiesDefaultOrder.filter(function (v) {
    return !pickExistFieldOrder.includes(v);
  })));
  if (pickExistFieldOrder.length === xAppOrders.length && restOrder.length === 0) {
    return xAppOrders;
  }
  return Array.from(new Set([].concat(pickExistFieldOrder, restOrder)));
}
function reOrderProps(schema) {
  return schema.properties;
}
exports.JsonSchemaStandard2AppJsonSchema = JsonSchemaStandard2AppJsonSchema;
exports.defaultOneOfSchema = defaultOneOfSchema;
exports.getActiveXAppOrder = getActiveXAppOrder;
exports.reOrderProps = reOrderProps;
